import styled from 'styled-components';

export const Container = styled.div`
  height: 100%;
  padding: 40px;

  .ant-tabs {
    overflow: visible;
    height: 100%;
  }

  .ant-tabs-content {
    height: 100%;
  }

  .ant-tabs-tab {
    padding: 8px;
    color: #1a1b1c;
  }

  .ant-tabs-tab + .ant-tabs-tab {
    margin-left: 48px !important;
  }

  .ant-tabs-tab-btn {
    color: #1a1b1c !important;
    font-size: 16px !important;
  }

  .ant-tabs-tab-disabled .ant-tabs-tab-btn {
    color: #838a91 !important;
  }

  .ant-tabs-ink-bar {
    background-color: #1371fe;
    height: 3px !important;
    border-radius: 1.5px !important;
  }
`;

export const Title = styled.div`
  font-size: 18px;
  font-weight: 500;
  color: #1a1b1c;
`;

export const Buttons = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 16px;
  margin-top: 30px;
`;

export const ErrorText = styled.div`
  font-size: 12px;
  font-weight: normal;
  color: #d14343;
  margin-top: 8px;

  &.truncated {
    text-overflow: ellipsis;
    overflow: hidden;
  }
`;
